module.exports = __webpack_public_path__ + "static/media/action-validated.64dd0682.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/action-validated.svg
 ** module id = 392
 ** module chunks = 0
 **/